import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCrown';
/** Renders an SVG icon. */
const SvgCrown = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M26 26a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zM14.632 4.602c.515-1.142 2.102-1.177 2.683-.106l.054.106 3.513 7.81 5.52-4.415c1.057-.845 2.603.03 2.425 1.37l-1.719 12.897A2 2 0 0 1 25.125 24H6.877a2 2 0 0 1-1.984-1.736L3.174 9.367c-.173-1.299 1.273-2.16 2.324-1.444l.1.074 5.52 4.416 3.514-7.81Zm-1.955 9.22a1.5 1.5 0 0 1-2.304.556L5.32 10.337 6.877 22h18.248l1.554-11.663-5.05 4.04a1.5 1.5 0 0 1-2.305-.555L16 6.436z"
      />
    </svg>
  );
};
SvgCrown.displayName = displayName;
export default SvgCrown;
